<template>
  <div>
    <DxPopup
      :visible="visible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :showTitle="true"
      :show-title="true"
      :title="gcSundryTransactionPopupConfig.title"
      :width="'90%'"
      :maxHeight="'720'"
      @hidden="gcSundryTransactionPopupConfig.gcPopupCallBack"
      :showCloseButton="false"
      :class="'sundry-transaction-model'"
      :titleTemplate="
        gcSundryTransactionPopupConfig.title ? undefined : 'titleTemplate'
      "
      :wrapperAttr="{ class: 'css-v2 gc-popup sundry-transaction-model' }"
    >
      <template #titleTemplate>
        <div class="title-container">
          <div v-if="popUpScreenOptions()">
            <DxSelectBox
              :items="popUpScreenOptions()"
              valueExpr="value"
              displayExpr="text"
              :onValueChanged="popUpScreenChangeCallback"
              :value="
                selectedScreen
                  ? selectedScreen
                  : popUpScreenOptions().find(
                      (element) => element.isDefault === true
                    ).value
              "
              :drop-down-options="{ width: 250 }"
            >
            </DxSelectBox>
          </div>
          <div
            class="custom-title"
            v-if="gcSundryTransactionPopupConfig.titleLines"
          >
            <div
              class="title-primary"
              v-for="popupTitleLine in gcSundryTransactionPopupConfig.titleLines"
              :key="popupTitleLine"
            >
              {{ popupTitleLine }}
            </div>
          </div>
          <div class="custom-title" v-else-if="!popupTitle">
            <span class="title-primary">{{ popupTitles.primary }}</span>
            <span class="title-secondary"> {{ popupTitles.secondary }}</span>
          </div>
          <div class="custom-title" v-else>
            <span class="title-primary">{{ popupTitle }}</span>
          </div>
        </div>
      </template>
      <DxScrollView
        id="scrollview"
        ref="scrollViewWidget"
        :scroll-by-content="true"
        :scroll-by-thumb="true"
        :show-scrollbar="'onScroll'"
      >
        <div>
          <div class="header-form css-v2 gc-popup-form">
            <gc-form
              :formOptions="formOptions"
              :formItems="formItems"
              :formHeight="'auto'"
              :isNormal="true"
              :data-model="dataModel"
              :formMode="baseView.mode"
              :validationGroup="'gc-popup-form-data'"
              :formTitle="'gc-popup'"
              v-if="formItems"
              :checkValid="isValid"
              :ref="'sundry-transaction-data-form'"
            ></gc-form>
          </div>

          <div class="css-v2 gc-popup-data-grid">
            <GcDataGrid
              :grouping="false"
              :export="false"
              :summary="false"
              :paging="false"
              :dataSourceConfig="dataSourceConfig"
              :columns="columns"
              :gridToolbar="gridToolbar"
              :padColumn="false"
              :id="'sundry-transaction-grid'"
              :auto-expand-all="false"
              :gridOptions="gridOptions"
              :gridHeightOverWrite="
                selectedScreen == 'new-sundry-payment' ? 434 : 374
              "
              :isLocalDataSource="true"
              :valueChangeListners="getListners"
              :ref="'sundry-transaction-grid'"
              :dxScrolling="'standard'"
              :rowRemoved="deleteRow"
              :isEditableGrid="true"
              :key="gridKey"
            />
          </div>

          <div class="footer-form">
            <gc-form
              :formOptions="formOptions"
              :formItems="footerFormItems"
              :formHeight="'auto'"
              :isNormal="true"
              :data-model="dataModel"
              :formMode="baseView.mode"
              :validationGroup="'gc-popup-form-data'"
              :formTitle="'gc-popup'"
              v-if="formItems"
              :checkValid="isValidFooter"
            ></gc-form>
          </div>

          <div class="footer">
            <DxButton
              class="save-btn"
              text="Save"
              type="default"
              styling-mode="contained"
              @click="handleSave"
              :disabled="handleSaveVisibility()"
            />
            <DxButton
              text="Cancel"
              type="default"
              styling-mode="contained"
              @click="popupHidden"
            />
          </div>
        </div>
      </DxScrollView>
    </DxPopup>
  </div>
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { JournalDetailServices } from "../_services/api/finance/journalDetail";
import { DivisionService } from "../_services/api/sales/division.service";
import { BranchService } from "../_services/api/sales/branch.service";
import { ProductService } from "../_services/api/products/product.service";
import { CompanyService } from "../_services/api/accounts/company.service";
import { getFactorByCode } from "../_store/helpers";
import { getDefaultUserSettings } from "../_store/helpers";
import { BankAccountTransactionServices } from "../_services/api/finance/bank-account-transaction.service";
import { ForeignCurrencyService } from "../_services/api/settings/accounting/foreign-currency.service";
import { FxToBaseCurrency } from "../_helpers/formulas/sales-formulas";

export default {
  props: {
    titleTemplate: {
      type: String,
      default: null,
    },
    visible: Boolean,
    gcSundryTransactionPopupConfig: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: function () {},
    },
    showValidationSummary: {
      type: Function,
      default: function () {},
    },
  },
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      isPopupHiddenBySave: false,
      isPopupHiddenByCancel: false,
      selectedScreen: undefined,
      formOptions: {
        gcLabelLocation: "left",
      },
      dataModel: {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
      },
      minDate: undefined,
      maxDate: undefined,
      currencyCode: undefined,
      localItems: [],
      glChartDataSourceItems: [],
      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      defaultBranchCode: undefined,
      defaultDivisionCode: undefined,
      isValid: false,
      isValidFooter: false,
      loaded: false,
      gridOptions: {
        dxScrolling: "standard",
      },
      disabledSave: true,
      gridKey: 0,
      loadItems: false,
      validationSummary: [],
      visibleAddNew: true,
    };
  },
  async created() {
    this.setLoading(true);
    await this.initialized();
    this.setLoading(false);
  },
  computed: {
    getListners() {
      return [
        {
          dataField: "GLChartCode",
          listner: (e, lineData) => {
            lineData.data.GLChartCode = e.itemData.ComputedStringCode;
            lineData.data.GLChartDescription = e.itemData.Description;
          },
        },
        {
          dataField: "BranchCode",
          listner: (e, lineData) => {
            lineData.data.BranchCode = e.itemData.Code;
            lineData.data.BranchDescription = e.itemData.Description;
          },
        },
        {
          dataField: "DivisionCode",
          listner: (e, lineData) => {
            lineData.data.DivisionCode = e.itemData.Code;
            lineData.data.DivisionDescription = e.itemData.Description;
          },
        },
        {
          dataField: "Comment",
          listner: (e, lineData) => {
            lineData.data.Comment = e.value;
          },
        },
        {
          dataField: "FxAmount",
          listner: ({ value }, lineData) => {
            lineData.data.FxAmount = value;
            lineData.data.Amount = FxToBaseCurrency(
              value,
              this.dataModel.ExchangeRate
            );
            if (this.isSundryPaymentScreen()) {
              this.setFxSundryPaymentSubTotal();
              this.setSundryPaymentTotal();
            } else {
              this.setFxSundryReceiptSubtotal();
              this.setSundryReceiptTotal();
            }

            this.$refs["sundry-transaction-grid"].gridRepaint();
          },
        },
        {
          dataField: "Amount",
          listner: ({ value }, lineData) => {
            lineData.data.Amount = value;
            lineData.data.FxAmount = value * this.dataModel.ExchangeRate;
            if (this.isSundryPaymentScreen()) {
              this.setFxSundryPaymentSubTotal();
              this.setSundryPaymentTotal();
            } else {
              this.setFxSundryReceiptSubtotal();
              this.setSundryReceiptTotal();
            }
            this.$refs["sundry-transaction-grid"].gridRepaint();
          },
        },
        {
          dataField: "ActionAddNew",
          listner: (e, lineData) => {
            if (!e) return;
            this.addNewRow(lineData, "add-new");
          },
        },
        {
          dataField: "ActionDelete",
          listner: (e, lineData) => {
            this.deleteRow(e, lineData);
          },
        },
        {
          dataField: "ActionCopy",
          listner: (e, lineData) => {
            if (!e) return;
            this.addNewRow(lineData, "copy-line");
          },
        },
      ];
    },
    dataSourceConfig() {
      return {
        localDataList: true,
        items: this.localItems,
        serverPaging: true,
        allowGrouping: false,
        postProcessCallback: undefined,
      };
    },
    gridToolbar() {
      return {
        search: true,
        columnChooser: false,
        export: false,
        openFilter: false,
        header: false,
      };
    },
    formItems() {
      if (this.isSundryPaymentScreen())
        return this.populateSundryPaymentHeader().items;
      else return this.populateSundryReceiptHeader().items;
    },
    footerFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: this.getFooterFormItems.filter((x) => x.visible != false)
            .length,
          items: this.getFooterFormItems.filter((x) => x.visible != false),
        },
      ];
    },
    getFooterFormItems() {
      return [
        {
          screenField: "FXTotal",
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentSubTotal"
            : "FxSundryReceiptSubTotal",
          location: "left",
          label: {
            text: `Sub Total(${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentTax"
            : "FxSundryReceiptTax",
          screenField: "FXTotal",
          location: "right",
          value: 0,
          label: {
            text: `Tax (${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "FxSundryPaymentTotal"
            : "FxSundryReceiptTotal",
          screenField: "FXTotal",
          location: "right",

          label: {
            text: `Total (${this.dataModel.CurrencyCode})`,
          },
          format: "Decimal-16-4C",
        },
        {
          dataField: this.isSundryPaymentScreen()
            ? "SundryPaymentTotal"
            : "SundryReceiptTotal",
          screenField: "FXTotal",
          location: "right",

          label: {
            text: `Total (${this.currencyCode})`,
          },
          format: "Decimal-16-4C",

          visible: this.dataModel.CurrencyCode != this.currencyCode,
        },
      ];
    },

    columns() {
      if (this.isSundryPaymentScreen())
        return this.populateSundryPaymentGrid().items;
      else return this.populateSundryReceiptGrid().items;
    },
  },
  watch: {
    visible(value) {
      if (value) this.initialized();
    },
    async selectedScreen(value) {
      if (value == "new-sundry-receipt") {
        if (this.dataModel.PaymentMethods.length == 0)
          BankAccountTransactionServices.getPaymentMethods().then(
            ({ data }) => {
              var PaymentMethods = data.value;
              this.dataModel.PaymentMethods = PaymentMethods;
              this.dataModel.SundryReceiptPaymentMethod = data.value.filter(
                (val) => val.isDefault === 1
              )[0].PayType;
            }
          );
        else {
          this.dataModel.SundryReceiptPaymentMethod =
            this.dataModel.PaymentMethods.filter(
              (val) => val.isDefault === 1
            )[0].PayType;
        }
      }
    },
  },

  methods: {
    async initialized() {
      await CompanyService.getCompany().then(({ data }) => {
        this.currencyCode = data.value[0].CurrencyCode;
        this.dataModel.CurrencyCode = data.value[0].CurrencyCode;
      });
      this.loadSundryReceiptBranch();
      this.loadSundryReceiptDivision();
      this.loadDate();
      this.loadDefaultScreen();
      await JournalDetailServices.getActiveAccountPeriod().then(({ data }) => {
        this.minDate = data.value[0].DateStart;
        this.maxDate = data.value[0].DateEnd;
      });
      await this.$store.dispatch("screenFactors/getFactors", [65, 66]);
      this.defaultBranchCode = getFactorByCode(65).Factorc;
      this.defaultDivisionCode = getFactorByCode(66).Factorc;
      if (this.localItems.length === 0) {
        this.localItems.push({
          GLChartCode: undefined,
          GLChartDescription: undefined,
          BranchCode: this.defaultBranchCode,
          BranchDescription: undefined,
          DivisionCode: this.defaultDivisionCode,
          DivisionDescription: undefined,
          Comment: undefined,
          Amount: 0,
          FxAmount: 0,
        });
      }
      await this.setBranchDataSourceItems();
      await this.setDivisionDataSourceItems();
      await this.setGLChartDataSourceItems();
    },
    loadDefaultScreen() {
      this.selectedScreen = this.popUpScreenOptions().find(
        (element) => element.isDefault === true
      ).value;
    },
    clearDataModel() {
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
      };
    },
    clearScreenData(e) {
      this.localItems.length = 0;
      this.selectedScreen = e.value;
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
      };
      if (e.value == "new-sundry-payment") {
        this.localItems.push({
          GLChartCode: undefined,
          GLChartDescription: undefined,
          BranchCode: this.defaultBranchCode,
          BranchDescription: undefined,
          DivisionCode: this.defaultDivisionCode,
          DivisionDescription: undefined,
          Comment: undefined,
          Amount: 0,
          FxAmount: 0,
        });
      } else {
        this.localItems.push({
          GLChartCode: undefined,
          GLChartDescription: undefined,
          Comment: undefined,
          Amount: 0,
          FxAmount: 0,
        });
      }
      if (e.value == "new-sundry-receipt") {
        if (this.dataModel.PaymentMethods.length == 0)
          BankAccountTransactionServices.getPaymentMethods().then(
            ({ data }) => {
              var PaymentMethods = data.value;
              this.dataModel.PaymentMethods = PaymentMethods;
              this.dataModel.SundryReceiptPaymentMethod = data.value.filter(
                (val) => val.isDefault === 1
              )[0].PayType;
            }
          );
        else {
          this.dataModel.SundryReceiptPaymentMethod =
            this.dataModel.PaymentMethods.filter(
              (val) => val.isDefault === 1
            )[0].PayType;
        }
      }

      CompanyService.getCompany().then(({ data }) => {
        this.currencyCode = data.value[0].CurrencyCode;
        this.dataModel.CurrencyCode = data.value[0].CurrencyCode;
      });
      this.loadSundryReceiptBranch();
      this.loadSundryReceiptDivision();
      this.loadDate();
    },
    clearSundryPaymentScreenData() {
      this.localItems.length = 0;
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
      };
      this.localItems.push({
        GLChartCode: undefined,
        GLChartDescription: undefined,
        BranchCode: this.defaultBranchCode,
        BranchDescription: undefined,
        DivisionCode: this.defaultDivisionCode,
        DivisionDescription: undefined,
        Comment: undefined,
        Amount: 0,
        FxAmount: 0,
      });
    },
    clearSundryReceiptScreenData() {
      this.localItems.length = 0;
      this.dataModel = {
        SundryPaymentDate: new Date(),
        SundryPaymentPayeeName: undefined,
        SundryPaymentAmount: undefined,
        SundryPaymentTax: 0.0,
        SundryPaymentBASReportable: true,
        SundryPaymentSupplierCode: undefined,
        FxSundryPaymentSubTotal: 0,
        SundryPaymentTotal: 0,
        FxSundryPaymentTotal: 0,

        FxSundryPaymentAmount: 0,
        FxSundryPaymentTax: 0.0,

        SundryReceiptDate: new Date(),
        SundryReceiptPayer: undefined,
        SundryReceiptCustomerCode: undefined,
        SundryReceiptPaymentMethod: undefined,
        SundryReceiptBranch: undefined,
        SundryReceiptDivision: undefined,
        SundryReceiptAmount: undefined,
        FxSundryReceiptAmount: 0.0,
        SundryReceiptTax: 0.0,
        FxSundryReceiptTax: 0.0,
        SundryReceiptBASReportable: true,
        SundryReceiptSubTotal: 0,
        FxSundryReceiptSubTotal: 0,
        SundryReceiptTotal: 0,
        FxSundryReceiptTotal: 0,
        CurrencyCode: undefined,
        ExchangeRate: 1,
        PaymentMethods: [],
      };
      this.localItems.push({
        GLChartCode: undefined,
        GLChartDescription: undefined,
        Comment: undefined,
        Amount: 0,
        FxAmount: 0,
      });
    },
    handleSaveVisibility() {
      if (this.isSundryPaymentScreen()) {
        return this.disableSundryPaymentSave();
      } else {
        return this.disableSundryReceiptSave();
      }
    },
    disableSundryPaymentSave() {
      return (
        this.dataModel.SundryPaymentAmount !=
          this.dataModel.SundryPaymentTotal ||
        this.dataModel.SundryPaymentTotal === 0
      );
    },
    disableSundryReceiptSave() {
      return (
        this.dataModel.SundryReceiptAmount !=
          this.dataModel.SundryReceiptTotal ||
        this.dataModel.SundryReceiptTotal === 0
      );
    },
    handleSave() {
      this.isSundryPaymentScreen()
        ? this.onGcSundryPaymentSave()
        : this.onGcSundryReceiptSave();
    },
    isSundryPaymentScreen() {
      return this.selectedScreen === "new-sundry-payment";
    },
    onSundryPaymentTaxChanged() {
      this.dataModel.FxSundryPaymentTotal =
        this.dataModel.FxSundryPaymentSubTotal +
        this.dataModel.FxSundryPaymentTax;

      this.dataModel.SundryPaymentTotal = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTotal,
        this.dataModel.ExchangeRate
      );
    },
    onSundryReceiptTaxChanged() {
      this.dataModel.FxSundryReceiptTotal =
        this.dataModel.FxSundryReceiptSubTotal +
        this.dataModel.FxSundryReceiptTax;
      this.dataModel.SundryReceiptTotal = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTotal,
        this.dataModel.ExchangeRate
      );
    },
    setSundryReceiptTotal() {
      this.dataModel.FxSundryReceiptTotal =
        this.dataModel.FxSundryReceiptSubTotal +
        this.dataModel.FxSundryReceiptTax;
      this.dataModel.SundryReceiptTotal = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTotal,
        this.dataModel.ExchangeRate
      );
    },
    setSundryPaymentTotal() {
      this.dataModel.FxSundryPaymentTotal =
        this.dataModel.FxSundryPaymentSubTotal +
        this.dataModel.FxSundryPaymentTax;

      this.dataModel.SundryPaymentTotal = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTotal,
        this.dataModel.ExchangeRate
      );
    },
    setFxSundryPaymentSubTotal() {
      let total = 0;
      this.localItems.forEach((localItem) => {
        total = total + localItem.FxAmount;
      });
      this.dataModel.FxSundryPaymentSubTotal = total;
    },
    setFxSundryReceiptSubtotal() {
      let total = 0;
      this.localItems.forEach((localItem) => {
        total = total + localItem.FxAmount;
      });
      this.dataModel.FxSundryReceiptSubTotal = total;
    },
    async onGcSundryReceiptSave() {
      var payload = {
        DateIn: this.dataModel.SundryReceiptDate,
        SundryReceiptDetails: [],
        Bsbno: this.gcSundryTransactionPopupConfig.dataModel.BSBNO,
        BankAccountNo: this.gcSundryTransactionPopupConfig.dataModel.AccountNo,
        DivisionCode: this.dataModel.SundryReceiptDivision,
        BranchCode: this.dataModel.SundryReceiptBranch,
        PayeeName: this.dataModel.SundryReceiptPayer,
        CustomerCode: this.dataModel.SundryReceiptCustomerCode,
        IsGstReportable: this.dataModel.SundryReceiptBASReportable,
        BankAccountCode: parseInt(
          this.gcSundryTransactionPopupConfig.dataModel.BankAccountCode
        ),
        ExTaxAmount: FxToBaseCurrency(
          this.dataModel.FxSundryReceiptSubTotal,
          this.dataModel.ExchangeRate
        ),
        TaxAmount: this.dataModel.SundryReceiptTax.roundNumber(2),
        IncTaxAmount: this.dataModel.SundryReceiptTotal.roundNumber(2),
        PaymentMethod: this.dataModel.SundryReceiptPaymentMethod,

        FXTaxAmount: this.dataModel.FxSundryReceiptTax,
        FXExTaxAmount: this.dataModel.FxSundryReceiptSubTotal,
        FXIncTaxAmount: this.dataModel.FxSundryReceiptTotal.roundNumber(2),
        ExchangeRate: this.dataModel.ExchangeRate,
        CurrencyCode: this.dataModel.CurrencyCode,
      };
      this.localItems.forEach((element) => {
        payload.SundryReceiptDetails.push({
          AccountCode: element.GLChartCode,
          Amount: element.Amount.roundNumber(2),
          FXAmount: element.FxAmount.roundNumber(2),
          Comment: element.Comment ? element.Comment : "",
        });
      });
      this.validationSummary = [];
      this.validateSundryReceiptGrid();
      this.validateSundryReceipt();
      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
      } else {
        this.setLoading(true);
        await BankAccountTransactionServices.saveSundryReceipt(payload)
          .then(async (res) => {
            if (res) {
              this.dataModel = {
                SundryPaymentDate: new Date(),
                SundryPaymentPayeeName: undefined,
                SundryPaymentAmount: undefined,
                SundryPaymentTax: 0.0,
                SundryPaymentBASReportable: true,
                SundryPaymentSupplierCode: undefined,
                FxSundryPaymentSubTotal: 0,
                SundryPaymentTotal: 0,
                FxSundryPaymentTotal: 0,

                FxSundryPaymentAmount: 0,
                FxSundryPaymentTax: 0.0,

                SundryReceiptDate: new Date(),
                SundryReceiptPayer: undefined,
                SundryReceiptCustomerCode: undefined,
                SundryReceiptPaymentMethod: undefined,
                SundryReceiptBranch: undefined,
                SundryReceiptDivision: undefined,
                SundryReceiptAmount: undefined,
                FxSundryReceiptAmount: 0.0,
                SundryReceiptTax: 0.0,
                FxSundryReceiptTax: 0.0,
                SundryReceiptBASReportable: true,
                SundryReceiptSubTotal: 0,
                FxSundryReceiptSubTotal: 0,
                SundryReceiptTotal: 0,
                FxSundryReceiptTotal: 0,
                CurrencyCode: undefined,
                ExchangeRate: 1,
                PaymentMethods: [],
              };
              this.localItems.forEach(() => this.localItems.pop());
              this.localItems.push({
                GLChartCode: undefined,
                GLChartDescription: undefined,
                Comment: undefined,
                Amount: 0,
                FxAmount: 0,
              });

              this.gcSundryTransactionPopupConfig.init();
              if (this.gcSundryTransactionPopupConfig.onSaveCallBack) {
                this.gcSundryTransactionPopupConfig.onSaveCallBack();
              }
              this.setLoading(false);
              this.gcSundryTransactionPopupConfig.gcPopupCallBack();
              this.isPopupHiddenBySave = true;
              await this.initialized();
            }
          })
          .catch((err) => {
            if (err) this.setLoading(false);
          });
      }
    },
    async onGcSundryPaymentSave() {
      var payload = {
        SupplierCode: this.dataModel.SundryPaymentSupplierCode,
        PayeeName: this.dataModel.SundryPaymentPayeeName,
        DateIn: this.dataModel.SundryPaymentDate.toSaveDate(),
        BankAccountCode: parseInt(
          this.gcSundryTransactionPopupConfig.dataModel.BankAccountCode
        ),
        GSTAmount: this.dataModel.SundryPaymentTax,
        IncTaxAmount: this.dataModel.SundryPaymentTotal.roundNumber(2),
        ExTaxAmount: FxToBaseCurrency(
          this.dataModel.FxSundryPaymentSubTotal,
          this.dataModel.ExchangeRate
        ),
        IsGstReportable: this.dataModel.SundryPaymentBASReportable,

        FXTaxAmount: this.dataModel.FxSundryPaymentTax,
        FXExTaxAmount: this.dataModel.FxSundryPaymentSubTotal,
        FXIncTaxAmount: this.dataModel.FxSundryPaymentTotal.roundNumber(2),
        ExchangeRate: this.dataModel.ExchangeRate,
        CurrencyCode: this.dataModel.CurrencyCode,
      };
      payload.SundryPaymentDetails = this.localItems.map((element) => {
        var data = {
          Amount: element.Amount.roundNumber(2),
          FXAmount: element.FxAmount.roundNumber(2),
          BranchCode: element.BranchCode,
          Comment: element.Comment ? element.Comment : "",
          DivisionCode: element.DivisionCode,
          AccountCode: element.GLChartCode,
          ItemCode: "",
        };
        return data;
      });
      this.validationSummary = [];
      this.validateSundryPaymentGrid();
      this.validateSundryPayment();
      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
      } else {
        this.setLoading(true);
        await BankAccountTransactionServices.saveSundryPayment(payload)
          .then(async (res) => {
            if (res) {
              this.localItems.forEach(() => this.localItems.pop());
              this.gcSundryTransactionPopupConfig.init();
              if (this.gcSundryTransactionPopupConfig.onSaveCallBack) {
                this.gcSundryTransactionPopupConfig.onSaveCallBack();
              }
              this.clearDataModel();
              this.setLoading(false);
              this.gcSundryTransactionPopupConfig.gcPopupCallBack();
              this.isPopupHiddenBySave = true;
              await this.initialized();
            }
          })
          .catch((err) => {
            if (err) this.setLoading(false);
          });
      }
    },
    loadDate() {
      this.dataModel.SundryPaymentDate = this.dataModel.SundryReceiptDate =
        new Date();
    },
    loadSundryReceiptDivision() {
      if (this.getUserDefaulDivision())
        this.dataModel.SundryReceiptDivision = this.getUserDefaulDivision();
      else
        this.dataModel.SundryReceiptDivision = this.getSystemDefaultDivision();
    },
    loadSundryReceiptBranch() {
      if (this.getUserDefaultBranch()) {
        this.dataModel.SundryReceiptBranch = this.getUserDefaultBranch();
      } else {
        this.dataModel.SundryReceiptBranch = this.getSystemDefaultBranch();
      }
    },
    getUserDefaulDivision() {
      return getDefaultUserSettings().DivisionCode;
    },
    async getSystemDefaultDivision() {
      var systemDefaultDivision = await DivisionService.getDefault();
      return systemDefaultDivision.data.value[0].Code;
    },

    getUserDefaultBranch() {
      return getDefaultUserSettings().BranchCode;
    },
    async getSystemDefaultBranch() {
      var systemDefaultBranch = await BranchService.getDefault();
      return systemDefaultBranch.data.value[0].Code;
    },

    populateSundryPaymentGrid() {
      return {
        value: "new-sundry-payment",
        items: [
          {
            screenField: "GLChart",
            dataField: "GLChartCode",
            label: "Account",
            cellTemplate: "SelectField",
            required: true,
            allowUpdate: true,
            allowSearch: true,
            dataSourceConfig: {
              data: this.glChartDataSourceItems,
            },
            makeReadOnly: () => false,
            visible: true,
            editorOptions: {
              searchExpr: ["ComputedStringCode", "Description"],
            },
            width: 200,
            dropDownOptions: {
              minWidth: 300,
            },
          },
          {
            screenField: "Code",
            dataField: "GLChartDescription",
            label: "Account Description",
            allowSearch: true,
            visible: false,
            width: 160,
          },
          {
            screenField: "Branch",
            dataField: "BranchCode",
            allowSearch: false,
            gridDataField: undefined,
            cellTemplate: "SelectField",
            makeReadOnly: () => false,
            allowUpdate: true,
            dataSourceConfig: {
              data: this.branchDataSourceItems,
            },
            width: 160,
          },
          {
            screenField: "Division",
            allowSearch: false,
            dataField: "DivisionCode",
            makeReadOnly: () => false,
            gridDataField: undefined,
            cellTemplate: "SelectField",
            allowUpdate: true,
            dataSourceConfig: {
              data: this.divisionDataSourceItems,
            },
            width: 160,
          },
          {
            screenField: "Comments",
            allowUpdate: true,
            dataField: "Comment",
            showEditorAlways: true,
            allowSearch: false,
            allowSorting: false,
            editCellTemplate: "EditableTextArea",
            makeDisabled: () => {
              return false;
            },
            makeReadOnly: () => false,
          },
          {
            screenField: "FXPrice",
            dataField: "FxAmount",
            label: `Amount (${this.dataModel.CurrencyCode})`,
            type: "EditableDecimal",
            allowUpdate: true,
            showEditorAlways: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,
            makeReadOnly: () => false,
          },
          {
            screenField: "Allocated",
            dataField: "Amount",
            label: "Amount (Base Currency)",
            type: "EditableDecimal",
            allowUpdate: false,
            showEditorAlways: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,
            makeReadOnly: () => true,
            visible: this.dataModel.CurrencyCode != this.currencyCode,
          },
          {
            dataField: "ActionAddNew",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionAddNew",
            cssClass: "class-custom-btn",
          },
          {
            dataField: "ActionDelete",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionDelete",
            cssClass: "class-custom-btn",
          },
          {
            dataField: "ActionCopy",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionCopy",
            cssClass: "class-custom-btn",
          },
        ],
      };
    },
    populateSundryReceiptGrid() {
      return {
        value: "new-sundry-receipt",
        items: [
          {
            screenField: "GLChart",
            dataField: "GLChartCode",
            label: "Account",
            cellTemplate: "SelectField",
            allowUpdate: true,
            allowSearch: true,
            dataSourceConfig: {
              data: this.glChartDataSourceItems,
            },
            visible: true,
            makeReadOnly: () => false,
            editorOptions: {
              searchExpr: ["ComputedStringCode", "Description"],
            },
            width: 200,
            dropDownOptions: {
              minWidth: 300,
            },
          },
          {
            screenField: "Code",
            dataField: "GLChartDescription",
            label: "Account",
            allowSearch: true,
            visible: false,
          },
          {
            screenField: "Comments",
            allowUpdate: true,
            dataField: "Comment",
            showEditorAlways: true,
            allowSearch: false,
            allowSorting: false,
            minWidth: 250,
            editCellTemplate: "EditableTextArea",
            makeDisabled: () => {
              return false;
            },
            makeReadOnly: () => false,
          },
          {
            screenField: "FXPrice",
            dataField: "FxAmount",
            label: `Amount (${this.dataModel.CurrencyCode})`,
            minWidth: 150,
            type: "EditableDecimal",
            allowUpdate: true,
            showEditorAlways: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,
            makeReadOnly: () => false,
          },
          {
            screenField: "FXPrice",
            dataField: "Amount",
            label: "Amount (Base Currency)",
            minWidth: 150,
            type: "EditableDecimal",
            allowUpdate: false,
            showEditorAlways: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,
            makeReadOnly: () => true,
            visible: this.dataModel.CurrencyCode != this.currencyCode,
          },
          {
            dataField: "ActionAddNew",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionAddNew",
            cssClass: "class-custom-btn",
          },
          {
            dataField: "ActionDelete",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionDelete",
            cssClass: "class-custom-btn",
          },
          {
            dataField: "ActionCopy",
            label: "",
            width: 50,
            minWidth: 50,
            cellTemplate: "ActionCopy",
            cssClass: "class-custom-btn",
          },
        ],
      };
    },
    populateSundryReceiptHeader() {
      return {
        value: "new-sundry-receipt",
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Date",
                    dataField: "SundryReceiptDate",
                    required: true,
                    label: {
                      text: "Date",
                    },
                    editorOptions: {
                      min: this.minDate,
                      max: this.maxDate,
                      allowUpdate: true,
                      search: true,
                    },
                  },
                  {
                    screenField: "Customer",
                    dataField: "SundryReceiptCustomerCode",
                    cssClass: "toolbar-customer-label",

                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "Customer Name",
                      showClearButton: true,
                      onItemClick: this.onCustomerCodeValueChanged.bind(this),
                    },
                    label: {
                      text: "Customer",
                    },
                    required: true,
                    filter:
                      this.gcSundryTransactionPopupConfig.dataModel
                        .FXCurrency != this.currencyCode
                        ? [
                            [
                              "CurrencyCode",
                              "=",
                              `${this.gcSundryTransactionPopupConfig.dataModel.FXCurrency}`,
                            ],
                          ]
                        : undefined,
                  },
                  {
                    screenField: "PayeeName",
                    dataField: "SundryReceiptPayer",
                    label: {
                      text: "Payer",
                    },
                    required: true,
                    editorOptions: {
                      allowUpdate: true,
                    },
                    defaultValue: this.dataModel.SundryReceiptPayer,
                  },
                  {
                    screenField: "PaymentMethod",
                    dataField: "SundryReceiptPaymentMethod",
                    cssClass: "toolbar-customer-label",
                    dataSourceConfig: {
                      data: this.dataModel.PaymentMethods,
                    },
                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "Payment Method",
                      showClearButton: true,
                    },
                    label: {
                      text: "Payment Method",
                    },
                    required: true,
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Branch",
                    dataField: "SundryReceiptBranch",
                    cssClass: "toolbar-customer-label",

                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "",
                      showClearButton: true,
                    },
                    label: {
                      text: "Branch",
                    },
                    dataSourceConfig: {
                      endpoint: "api/Branch",
                      sort: {
                        selector: "Code",
                        asc: true,
                      },
                      filter: [["Inactive", "=", "N"]],
                    },
                    required: true,
                  },
                  {
                    screenField: "Division",
                    dataField: "SundryReceiptDivision",
                    cssClass: "toolbar-customer-label",

                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "",
                      showClearButton: true,
                    },
                    dataSourceConfig: {
                      endpoint: "api/Division",
                      sort: {
                        selector: "Code",
                        asc: true,
                      },
                      filter: [["Inactive", "=", "N"]],
                    },
                    label: {
                      text: "Division",
                    },
                    required: true,
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 2,
                    items: [
                      {
                        screenField: "Currency",
                      },
                      {
                        screenField: "ExchangeRate",
                        editorOptions: {
                          allowUpdate:
                            this.dataModel.CurrencyCode != this.currencyCode,
                          onValueChanged: (e) => {
                            this.dataModel.ExchangeRate = e.value;
                            this.localItems.forEach((element) => {
                              element.Amount = FxToBaseCurrency(
                                element.FxAmount,
                                e.value
                              );
                            });

                            this.dataModel.SundryReceiptAmount =
                              this.dataModel.FxSundryReceiptAmount /
                              this.dataModel.ExchangeRate;
                            this.dataModel.SundryReceiptTax =
                              this.dataModel.FxSundryReceiptTax /
                              this.dataModel.ExchangeRate;
                            this.onSundryReceiptTaxChanged();
                          },
                        },
                      },
                    ],
                  },
                  {
                    dataField: "SundryReceiptBASReportable",
                    label: {
                      text: "BAS Reportable",
                    },
                    cssClass: "myCss",
                    editorType: "dxCheckBox",
                    editorOptions: {
                      allowUpdate: true,
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 2,
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 1,
                    items: [
                      {
                        screenField: "FXAmount",
                        dataField: "FxSundryReceiptAmount",
                        format: "Decimal-16-2",
                        required: true,
                        label: {
                          text: `Amount (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: (e) => {
                            this.dataModel.FxSundryReceiptAmount = e.value;
                            this.dataModel.SundryReceiptAmount =
                              FxToBaseCurrency(
                                e.value,
                                this.dataModel.ExchangeRate
                              );
                          },
                        },
                      },
                      {
                        screenField: "FXAmount",
                        dataField: "SundryReceiptAmount",
                        format: "Decimal-16-2",
                        required: true,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Amount (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: (e) => {
                          //   this.dataModel.SundryReceiptAmount = e.value;
                          //   this.dataModel.FxSundryReceiptAmount =
                          //     e.value * this.dataModel.ExchangeRate;
                          // },
                        },
                      },
                    ],
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 1,
                    items: [
                      {
                        screenField: "TaxTotal",
                        dataField: "FxSundryReceiptTax",
                        format: "Decimal-16-2",
                        required: false,
                        label: {
                          text: `Tax (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: ({ value }) => {
                            this.dataModel.FxSundryReceiptTax = value;
                            this.dataModel.SundryReceiptTax = FxToBaseCurrency(
                              value,
                              this.dataModel.ExchangeRate
                            );
                            this.onSundryReceiptTaxChanged(value);
                          },
                        },
                      },
                      {
                        screenField: "TaxTotal",
                        dataField: "SundryReceiptTax",
                        format: "Decimal-16-2",
                        required: false,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Tax (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: ({ value }) => {
                          //   this.dataModel.SundryReceiptTax = value;
                          //   this.dataModel.FxSundryReceiptTax =
                          //     value * this.dataModel.ExchangeRate;
                          //   this.onSundryReceiptTaxChanged();
                          // },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    populateSundryPaymentHeader() {
      return {
        value: "new-sundry-payment",
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Date",
                    dataField: "SundryPaymentDate",
                    required: true,
                    label: {
                      text: "Date",
                    },
                    editorOptions: {
                      min: this.minDate,
                      max: this.maxDate,
                      allowUpdate: true,
                      search: true,
                    },
                  },
                  {
                    screenField: "Supplier",
                    dataField: "SundryPaymentSupplierCode",
                    cssClass: "toolbar-customer-label",

                    editorOptions: {
                      allowUpdate: true,
                      dropDownOptions: {
                        minWidth: 220,
                      },
                      placeholder: "Supplier Name",
                      showClearButton: true,
                      onItemClick: this.onSupplierCodeValueChanged.bind(this),
                    },
                    label: {
                      text: "Supplier",
                    },
                    required: true,
                    filter:
                      this.gcSundryTransactionPopupConfig.dataModel
                        .FXCurrency != this.currencyCode
                        ? [
                            [
                              "CurrencyCode",
                              "=",
                              `${this.gcSundryTransactionPopupConfig.dataModel.FXCurrency}`,
                            ],
                          ]
                        : undefined,
                  },
                  {
                    dataField: "SundryPaymentBASReportable",
                    label: {
                      text: "BAS Reportable",
                    },
                    cssClass: "myCss",
                    editorType: "dxCheckBox",
                    editorOptions: {
                      allowUpdate: true,
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "PayeeName",
                    dataField: "SundryPaymentPayeeName",
                    label: {
                      text: "Payee",
                    },
                    required: true,
                    editorOptions: {
                      allowUpdate: true,
                    },
                    defaultValue: this.PayeeName,
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 2,
                    items: [
                      {
                        screenField: "Currency",
                      },
                      {
                        screenField: "ExchangeRate",
                        editorOptions: {
                          allowUpdate:
                            this.dataModel.CurrencyCode != this.currencyCode,
                          onValueChanged: (e) => {
                            this.dataModel.ExchangeRate = e.value;

                            this.localItems.forEach((element) => {
                              element.Amount = FxToBaseCurrency(
                                element.FxAmount,
                                e.value
                              );
                            });

                            this.dataModel.SundryPaymentAmount =
                              this.dataModel.FxSundryPaymentAmount /
                              this.dataModel.ExchangeRate;
                            this.dataModel.SundryPaymentTax =
                              this.dataModel.FxSundryPaymentTax /
                              this.dataModel.ExchangeRate;
                            this.onSundryPaymentTaxChanged();
                          },
                        },
                      },
                    ],
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                colCount: 2,
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 1,
                    items: [
                      {
                        screenField: "FXAmount",
                        dataField: "FxSundryPaymentAmount",
                        format: "Decimal-16-2",
                        required: true,
                        label: {
                          text: `Amount (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: (e) => {
                            this.dataModel.FxSundryPaymentAmount = e.value;
                            this.dataModel.SundryPaymentAmount =
                              FxToBaseCurrency(
                                e.value,
                                this.dataModel.ExchangeRate
                              );
                          },
                        },
                      },
                      {
                        screenField: "FXAmount",
                        dataField: "SundryPaymentAmount",
                        format: "Decimal-16-2",
                        required: true,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Amount (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: (e) => {
                          //   this.dataModel.SundryPaymentAmount = e.value;
                          //   this.dataModel.FxSundryPaymentAmount =
                          //     e.value * this.dataModel.ExchangeRate;
                          // },
                        },
                      },
                    ],
                  },
                  {
                    itemType: "group",
                    caption: "",
                    colCount: 1,
                    items: [
                      {
                        screenField: "TaxTotal",
                        dataField: "FxSundryPaymentTax",
                        format: "Decimal-16-2",
                        required: false,
                        label: {
                          text: `Tax (${this.dataModel.CurrencyCode})`,
                        },
                        editorOptions: {
                          allowUpdate: true,
                          onValueChanged: ({ value }) => {
                            this.dataModel.FxSundryPaymentTax = value;
                            this.dataModel.SundryPaymentTax = FxToBaseCurrency(
                              value,
                              this.dataModel.ExchangeRate
                            );

                            this.onSundryPaymentTaxChanged();
                          },
                        },
                      },
                      {
                        screenField: "TaxTotal",
                        dataField: "SundryPaymentTax",
                        format: "Decimal-16-2",
                        required: false,
                        visible:
                          this.dataModel.CurrencyCode != this.currencyCode,
                        label: {
                          text: `Tax (${
                            getDefaultUserSettings().CurrencyCode
                          })`,
                        },
                        editorOptions: {
                          // allowUpdate: true,
                          // onValueChanged: ({ value }) => {
                          //   this.dataModel.SundryPaymentTax = value;
                          //   this.dataModel.FxSundryPaymentTax =
                          //     value * this.dataModel.ExchangeRate;
                          //   this.onSundryPaymentTaxChanged();
                          // },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    popUpScreenOptions() {
      return [
        {
          value: "new-sundry-payment",
          text: "New Sundry Payment",
          isDefault: true,
        },
        {
          value: "new-sundry-receipt",
          text: "New Sundry Receipt",
          isDefault: false,
        },
      ];
    },
    async popUpScreenChangeCallback(e) {
      if (this.isPopupHiddenBySave) {
        this.clearScreenData(e);
        this.isPopupHiddenBySave = false;
      } else if (this.isPopupHiddenByCancel) {
        this.clearScreenData(e);
        this.isPopupHiddenByCancel = false;
      } else {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave ?",
          "Unsaved Changes"
        );
        if (confirmLeaving) {
          this.clearScreenData(e);
        }
      }
    },
    async onSupplierCodeValueChanged(e) {
      let itemData = e.itemData;
      if (!itemData) {
        return;
      }
      this.dataModel.SundryPaymentSupplierCode = itemData.Code;
      this.dataModel.SundryPaymentPayeeName = itemData.Name;

      this.dataModel.CurrencyCode = itemData.CurrencyCode;

      let currency = await ForeignCurrencyService.getByCode(
        itemData.CurrencyCode
      );

      this.dataModel.ExchangeRate = currency.data.value[0].SellRate;

      this.dataModel.SundryPaymentAmount = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentAmount,
        this.dataModel.ExchangeRate
      );
      this.dataModel.SundryPaymentTax = FxToBaseCurrency(
        this.dataModel.FxSundryPaymentTax,
        this.dataModel.ExchangeRate
      );
      this.onSundryPaymentTaxChanged();
    },
    async onCustomerCodeValueChanged(e) {
      let itemData = e.itemData;
      if (!itemData) {
        return;
      }
      this.dataModel.SundryReceiptCustomerCode = itemData.Code;
      this.dataModel.SundryReceiptPayer = itemData.Name;

      this.dataModel.CurrencyCode = itemData.CurrencyCode;

      let currency = await ForeignCurrencyService.getByCode(
        itemData.CurrencyCode
      );

      this.dataModel.ExchangeRate = currency.data.value[0].BuyRate;

      this.dataModel.SundryReceiptAmount = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptAmount,
        this.dataModel.ExchangeRate
      );
      this.dataModel.SundryReceiptTax = FxToBaseCurrency(
        this.dataModel.FxSundryReceiptTax,
        this.dataModel.ExchangeRate
      );
      this.onSundryReceiptTaxChanged();
    },
    async setGLChartDataSourceItems() {
      let branchDS = ProductService.dataSourceConfig("api/GLChart", {
        filter: [
          ["Inactive", "=", "N"],
          "and",
          ["Status", "=", "A"],
          "and",
          ["IsControlAcct", "<>", "Y"],
        ],
        sort: [{ selector: "ComputedStringCode", asc: true }],
        preventPagination: true,
      });
      this.glChartDataSourceItems = await branchDS.load();
    },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });
      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });
      this.branchDataSourceItems = await branchDS.load();
    },
    addNewRow(lineData, type) {
      this.validationSummary = [];
      var validation = [];
      if (this.isSundryPaymentScreen()) {
        if (!lineData.data.GLChartCode)
          validation.push({
            message: "Account field is required",
          });

        if (!lineData.data.BranchCode)
          validation.push({
            message: "Branch field is required",
          });

        if (!lineData.data.DivisionCode)
          validation.push({
            message: "Division field is required",
          });

        if (!lineData.data.Amount)
          validation.push({
            message: "Amount field is required",
          });
      } else {
        if (!lineData.data.GLChartCode)
          validation.push({
            message: "Account field is required",
          });
        if (!lineData.data.Amount)
          validation.push({
            message: "Amount field is required",
          });
      }

      if (validation.length > 0) {
        this.showValidationSummary(validation);
      } else {
        var copyItem;
        if (this.isSundryPaymentScreen()) {
          if (type == "add-new")
            this.localItems.push({
              GLChartCode: undefined,
              GLChartDescription: undefined,
              BranchCode: this.defaultBranchCode,
              BranchDescription: undefined,
              DivisionCode: this.defaultDivisionCode,
              DivisionDescription: undefined,
              Comment: undefined,
              Amount: 0,
              FxAmount: 0,
            });
          else {
            copyItem = { ...lineData.data };
            this.localItems.push(copyItem);
            this.setFxSundryPaymentSubTotal();
            this.setSundryPaymentTotal();
          }
        } else {
          if (type == "add-new")
            this.localItems.push({
              GLChartCode: undefined,
              GLChartDescription: undefined,
              Comment: undefined,
              Amount: 0,
              FxAmount: 0,
            });
          else {
            copyItem = { ...lineData.data };
            this.localItems.push(copyItem);
            this.setFxSundryReceiptSubtotal();
            this.setSundryReceiptTotal();
          }
        }
      }
    },
    async deleteRow(e, lineData) {
      if (!e) return;
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this line ?",
        "Delete Record"
      );

      if (confirmDelete) {
        this.localItems.splice(lineData.rowIndex, 1);
        if (this.isSundryPaymentScreen()) {
          this.setFxSundryPaymentSubTotal();
          this.setSundryPaymentTotal();
          if (this.localItems.length == 0) {
            this.localItems.push({
              GLChartCode: undefined,
              GLChartDescription: undefined,
              BranchCode: this.defaultBranchCode,
              BranchDescription: undefined,
              DivisionCode: this.defaultDivisionCode,
              DivisionDescription: undefined,
              Comment: undefined,
              Amount: 0,
              FxAmount: 0,
            });
          }
        } else {
          this.setFxSundryReceiptSubtotal();
          this.setSundryReceiptTotal();
          if (this.localItems.length == 0) {
            this.localItems.push({
              GLChartCode: undefined,
              GLChartDescription: undefined,
              Comment: undefined,
              Amount: 0,
              FxAmount: 0,
            });
          }
        }
      }
    },
    async popupHidden() {
      var confirmLeaving = await this.$confirm(
        "You have unsaved changes. Are you sure you want to leave ?",
        "Unsaved Changes"
      );
      if (confirmLeaving) {
        this.gcSundryTransactionPopupConfig.gcPopupCallBack();
        if (this.isSundryPaymentScreen()) {
          this.clearSundryPaymentScreenData();
        } else {
          this.isPopupHiddenByCancel = true;
          this.loadDefaultScreen();
        }
      }
    },
    validateSundryPayment() {
      this.validateDate();
      this.validateSupplier();
      this.validatePayee();
      this.validateAmount();
    },
    validateSundryReceipt() {
      this.validateDate();
      this.validatePayee();
      this.validateAmount();
      this.validateCustomer();
      this.validatePaymentMethod();
      this.validateBranch();
      this.validateDivision();
    },
    validateSundryPaymentGrid() {
      this.localItems.forEach((localItem) => {
        this.validateSundryPaymentAccount(localItem);
        this.validateSundryPaymentGridAmount(localItem);
        this.validateSundryPaymentGridBranch(localItem);
        this.validateSundryPaymentGridDivision(localItem);
      });
    },
    validateSundryReceiptGrid() {
      this.localItems.forEach((localItem) => {
        this.validateSundryPaymentAccount(localItem);
        this.validateSundryPaymentGridAmount(localItem);
      });
    },
    validateSundryPaymentAccount(item) {
      if (item.GLChartCode == undefined) {
        this.validationSummary.push({ message: "Account feild is required" });
      }
    },
    validateSundryPaymentGridAmount(item) {
      if (item.Amount == undefined) {
        this.validationSummary.push({ message: "Amount feild is required" });
      }
    },
    validateSundryPaymentGridBranch(item) {
      if (item.BranchCode == undefined) {
        this.validationSummary.push({ message: "Branch feild is required" });
      }
    },
    validateSundryPaymentGridDivision(item) {
      if (item.DivisionCode == undefined) {
        this.validationSummary.push({ message: "Division feild is required" });
      }
    },
    validateSupplier() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentSupplierCode == undefined)
          this.validationSummary.push({
            message: "Supplier field is required",
          });
      }
    },
    validateDate() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentDate == undefined)
          this.validationSummary.push({ message: "Date field is required" });
      } else {
        if (this.dataModel.SundryReceiptDate == undefined)
          this.validationSummary.push({ message: "Date field is required" });
      }
    },
    validatePayee() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentPayeeName == undefined)
          this.validationSummary.push({ message: "Payee field is required" });
      } else {
        if (this.dataModel.SundryReceiptPayer == undefined)
          this.validationSummary.push({ message: "Payer field is required" });
      }
    },
    validateAmount() {
      if (this.isSundryPaymentScreen()) {
        if (this.dataModel.SundryPaymentAmount == undefined)
          this.validationSummary.push({ message: "Amount field is required" });
      } else {
        if (this.dataModel.SundryReceiptAmount == undefined)
          this.validationSummary.push({ message: "Amount field is required" });
      }
    },
    validateCustomer() {
      if (this.dataModel.SundryReceiptCustomerCode == undefined)
        this.validationSummary.push({ message: "Customer feild is required" });
    },
    validatePaymentMethod() {
      if (this.dataModel.SundryReceiptPaymentMethod == undefined)
        this.validationSummary.push({
          message: "Payment Method feild is required",
        });
    },
    validateBranch() {
      if (this.dataModel.SundryReceiptBranch == undefined)
        this.validationSummary.push({ message: "Branch feild is required" });
    },
    validateDivision() {
      if (this.dataModel.SundryReceiptDivision == undefined)
        this.validationSummary.push({ message: "Division feild is required" });
    },
  },
};
</script>

<style lang="scss">
.sundry-transaction-model {
  .header-form {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .footer-form {
    margin-top: 0 !important;
    display: flex;
    justify-content: flex-end;
    margin: 0 10px 10px 10px;
    background-color: white;
    border-radius: 3px;
  }
  .custom-title {
    margin-left: 50px;
  }
  .title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .footer {
    .save-btn {
      margin-right: 25px;
    }
  }
}
</style>
